// Consumable phases of a generic product.
// Keys match serviceUtilization phases (laboratory/catalog/preAnalytical) and the
// `phases` values in constants/genericProducts.json
export const CONSUMABLE_PHASES = [
  { key: "preAnalytical", abbr: "PRE", label: "Pre-analytical", color: "info" },
  { key: "analytical", abbr: "ANA", label: "Analytical", color: "primary" },
  {
    key: "postAnalytical",
    abbr: "POST",
    label: "Post-analytical",
    color: "secondary",
  },
  { key: "general", abbr: "GEN", label: "General (all phases)", color: "default" },
];

export const getPhase = (key) =>
  CONSUMABLE_PHASES.find((phase) => phase.key === key);

/**
 * Whether a generic can be used in the given phase.
 * Untagged generics are allowed everywhere so old records stay usable.
 */
export const isUsableIn = (phases = [], phase) =>
  !phases.length || phases.includes("general") || phases.includes(phase);
